<script lang="ts">
  import { setIsInsideModal } from "./context.ts";
  import { onDestroy } from "svelte";
  import { Ver } from "../../layouts/mod.ts";
  import { Separator } from "../mod.ts";

  setIsInsideModal(true);
  interface Props {
    customClass?: string;
    onBackdropPressed?: (e?: Event) => void;
    title?: string | null;
  }

  const { customClass = "", onBackdropPressed = () => {}, title }: Props =
    $props();

  let node = $state<Node | null>(null);

  function portalAction(otherNode: Node) {
    node = otherNode;
    document.body.appendChild(node);
  }

  onDestroy(() => {
    if (node) {
      try {
        document.body.removeChild(node);
      } catch {
      }
    }
  });

</script>

<div
  on:mousedown|self={onBackdropPressed}
  use:portalAction
  role={undefined}
  aria-label="Close dialog"
  class="
    top-0 left-0 bottom-0 right-0 z-50 fixed w-full h-full bg-black bg-opacity-50
    align-middle flex flex-wrap justify-center items-center max-mobile:px-[8px] overflow-y-scroll
  "
>
  <div
    class="card bg-[#FFFFFF] rounded-[10px] shadow-card max-mobile:inherit-width {customClass}"
  >
    <div class="w-full">
      {#if title}
        <div class="px-[24px] py-[24px] max-mobile:px-[16px]">
          <h2 class="text-[#181818] text-[18px]">{title}</h2>
        </div>
        <Separator />
        <div class="mt-2 mb-4 mx-4">
          <Ver>
            <slot />
          </Ver>
        </div>
      {:else}
        <slot />
      {/if}
    </div>
  </div>
</div>
